import { mapGetters } from "vuex";
import * as types from "@/store/types";

const VerifyChip = () =>
  import(
    /* webpackChunkName: "VerifyChip" */ "@/components/AccountPage/Personal/VerifyChip/index"
  );

const PictureVerifyChip = () =>
  import(
    /* webpackChunkName: "PictureVerifyChip" */ "@/components/AccountPage/Personal/PictureVerifyChip/index"
  );

export default {
  name: "personal-status",
  components: { VerifyChip, PictureVerifyChip },
  computed: {
    ...mapGetters({
      verifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),

    isVerify() {
      return this.verifyInfo?.is_verified;
    },

    personalStatus() {
      return this.verifyInfo?.personal_information_status;
    },

    completionPercent() {
      return this.verifyInfo?.completion_profile_status
        ?.total_completion_percent;
    },
    checkPhoneStatus() {
      return (
        this.verifyInfo?.home_phone_verification_status === "VERIFIED" ||
        this.verifyInfo?.home_phone_verification_status === "SUBMITTED"
      );
    },

    contactStatus() {
      return this.verifyInfo?.email_verification_status === "VERIFIED" &&
        this.verifyInfo?.mobile_verification_status === "VERIFIED" &&
        this.checkPhoneStatus
        ? "VERIFIED"
        : "REJECTED";
    },

    identityStatus() {
      if (this.verifyInfo.is_in_auto_verification) {
        if (
          this.IDCardStatus === "VERIFIED" &&
          this.videoStatus === "VERIFIED"
        ) {
          return "VERIFIED";
        } else if (
          this.IDCardStatus === "PROCESSING" ||
          this.videoStatus === "PROCESSING"
        ) {
          return "PROCESSING";
        } else {
          return "REJECTED";
        }
      } else {
        return this.verifyInfo?.verification_image.status.value;
      }
    },
    IDCardStatus() {
      return this.verifyInfo?.id_card_status;
    },
    videoStatus() {
      return this.verifyInfo?.video_status;
    },

    isApprove() {
      return (
        this.IDCardStatus === "VERIFIED" && this.videoStatus === "VERIFIED"
      );
    },
    phoneStatus() {
      return this.verifyInfo?.home_phone_verification_status;
    },

    emailStatus() {
      return this.verifyInfo?.email_verification_status;
    },
    mobileStatus() {
      return this.verifyInfo?.mobile_verification_status;
    }
  }
};
